<div mdbModal #asignarAutomaticaCamionRutas="mdb-modal" class="modal fade" id="dvModalAsignarAutomaticaCamionRutas"
  tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" style="max-width:60%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Asignar Automática Camión
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrarModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div>
        <form [formGroup]="formFiltrosDocumentos">
          <div class="card mb-2 wow detalle-cliente">
            <div class="card-body justify-content-between">
              <div class="row filtros-body">

                <ng-container *ngIf="permiteUnidadNegocio">
                  <div class="col" style="max-width: 300px;">
                    <div class="md-form">
                      <mdb-select label="Unidad de Negocio" [options]="optionsUnidadesDeNegocio"
                        placeholder="Unidad de negocio" [filterEnabled]="true" formControlName="unidad_negocio_codigo">
                      </mdb-select>
                      <div *ngIf="
                              formFiltrosDocumentos.get('unidad_negocio_codigo').invalid &&
                              (formFiltrosDocumentos.get('unidad_negocio_codigo').dirty ||
                              formFiltrosDocumentos.get('unidad_negocio_codigo').touched)
                            ">
                        <mdb-error *ngIf="formFiltrosDocumentos.get('unidad_negocio_codigo').hasError('required')">
                          Ingrese unidad de negocio
                        </mdb-error>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="col" style="max-width: 200px;">
                  <div class="md-form mb-0">
                    <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha"
                      id="fechafiltroDesde" #fechafiltro formControlName="filtroFechaDesde" required></mdb-date-picker>
                    <label>Desde</label>
                  </div>
                </div>
                <div class="col" style="max-width: 200px;">
                  <div class="md-form mb-0">
                    <mdb-date-picker [options]="myDatePickerOptions" [inline]="true" placeholder="Fecha"
                      id="fechafiltroHasta" #fechafiltro formControlName="filtroFechaHasta" required></mdb-date-picker>
                    <label>Hasta</label>
                  </div>
                </div>
                <div class="col" style="max-width: 300px;">
                  <div class="md-form mb-0">
                    <mdb-select (ngModelChange)="changeComuna($event)" [options]="optionsComuna" [multiple]="true"
                      [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Comuna"
                      formControlName="filtroComuna">
                    </mdb-select>
                    <label>Comuna</label>
                  </div>
                </div>
                <div class="col" style="max-width: 300px;">
                  <div class="md-form mb-0">
                    <mdb-select (ngModelChange)="changeVendedor($event)" [options]="optionsVendedor" [multiple]="true"
                      [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar Vendedor"
                      id="vendedorfiltro" #vendedorfiltro formControlName="filtroVendedor">
                    </mdb-select>
                    <label>Vendedor</label>
                  </div>
                </div>
                <div class="col" style="max-width: 300px;">
                  <div class="md-form mb-0">
                    <mdb-select (ngModelChange)="changeTerritorio($event)" [options]="optionsTerritorios"
                      [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                      placeholder="Seleccionar Terrirorio" id="territoriofiltro" #territoriofiltro
                      formControlName="filtroTerritorio">
                    </mdb-select>
                    <label>Territorio</label>
                  </div>
                </div>
                <div class="col" style="max-width: 150px;">
                  <div class="md-form">
                    <input value="" type="number" id="nroDoc" class="form-control" placeholder="Distacias" #nroDoc />
                    <label for="nroDoc">Distancia</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- FOOTER -->
            <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
              <div class="resultados pl-2">
                <div class="resultados pl-2">
                  <strong>Total Documentos</strong>
                  <span class="dummyTxt" *ngIf="documentosRecorridos?.length === 0">0</span>
                  <span class="dummyTxt" *ngIf="documentosRecorridos?.length > 0 null">{{documentos_pendientes}}</span>
                  <strong>Clientes</strong>
                  <span class="dummyTxt" *ngIf="documentosRecorridos?.length === 0">0</span>
                  <span class="dummyTxt" *ngIf="documentosRecorridos?.length > 0">{{numeros_clientes}}</span>
                </div>
              </div>
              <div>
                <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="buscarPorFiltros()">
                  <mdb-icon fas icon="search"></mdb-icon>
                  Buscar
                </button>
                <button mdbBtn type="submit" color="secondary" size="sm" mdbWavesEffect (click)="limpiarFiltros()">
                  Limpiar
                </button>
              </div>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-body">
        <div class="card-body justify-content-between">
          <div class="table-striped" *ngIf="listadoCamionChoferDisponible">
            <!-- <div *ngIf="selected">
              {{selected | json}}
            </div> -->
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">
                    <mdb-checkbox [checked]="false" (change)="checkAllChange($event)"></mdb-checkbox>
                  </th>
                  <th scope="col">N° Recorrido</th>
                  <th scope="col">Patente</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Descripción</th>
                  <th scope="col">Chofer</th>
                  <th scope="col">Peso</th>
                  <th scope="col">Volumen</th>
                  <th scope="col">Opciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="100%" style="text-align: center">
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                  </td>
                </tr>
                <tr *ngIf="!loading && listadoCamionChoferDisponible?.length === 0">
                  <td colspan="100%" style="text-align: center">
                    No se encontró información
                  </td>
                </tr>
                <ng-container *ngFor="let cam of listadoCamionChoferDisponible; let i = index;">
                  <tr *ngIf="cam.total_facturas == 0">
                    <mdb-checkbox [checked]="cam.additionalInfo.checked" (change)="checkItem(cam.additionalInfo)">
                    </mdb-checkbox>
                    <td>{{ cam.recorrido_codigo }}</td>
                    <td>{{ cam.patente }}</td>
                    <td>{{ cam.fecha | fecha }}</td>
                    <td>{{ cam.descripcion_camion }}</td>
                    <td>{{ cam.nombre_chofer }}</td>
                    <!-- <td>$ {{ camChofDisp.total_facturas | numerico }}</td> -->
                    <td> {{ cam.peso_maximo_camion | numerico }}</td>
                    <td> {{ cam.volumen_maximo_camion | numerico }}</td>
                    <td>
                      <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                        (click)="editarRecorrido(cam)" mdbTooltip="Editar recorrido" placement="right">
                        <mdb-icon fas icon="pen"></mdb-icon>
                      </button>
                      <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                        (click)="confirmEliminar(cam)" mdbTooltip="Eliminar" placement="right"
                        [disabled]="cam.total_facturas > 0">
                        <mdb-icon fas icon="trash"></mdb-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listadoCamionChoferDisponibleAll?.length > 0"></app-pagination>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="cerrarModal()" mdbWavesEffect>
          Cerrar
        </button>
        <button size="sm" *ngIf="edicionRecorrido" type="button" class="btn btn-sm btn-secondary waves-light"
          mdbWavesEffect (click)="ClonarRecorrido();">
          Clonar
        </button>
        <button size="sm" class="btn btn-sm btn-secondary waves-light" type="button" mdbWavesEffect data-toggle="modal"
          data-target="#dvModalAsignarAutomaticaCamionRutas" (click)="requestShowModalRutas()" placement="right">
          Crear Ruta
        </button>
        <app-api-button *ngIf="!edicionRecorrido" type="button" mdbWavesEffect (click2)="AsignarAutomaticaCamion();"
          [processing]="processing">
          Procesar
        </app-api-button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL CLONAR -->
<app-modal-clonar-recorrido (onAccept)="UpdateEditarRutas();"></app-modal-clonar-recorrido>

<!-- MODAL CREAR RUTA -->
<app-modal-add-edit-ruta (onSuccess)="onCargarRuta()"></app-modal-add-edit-ruta>

<app-modal-confirm>
</app-modal-confirm>